import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

import { IActiveButton, IMargin } from './types';

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: ${primitive.$spacing4} 0;
`;

export const TimCardTextImageContainer = styled.div`
  height: 24px;
  flex: 1;
  & > div > img {
    width: unset !important;
    max-width: 100% !important;
  }
`;

export const Balance = styled.span`
  font-size: 1.25rem;
  color: ${primitive.th.$coffeeBrown};
  font-weight: ${Styles.fontWeight.heavy};
`;

export const CurrencySymbol = styled.span`
  margin-right: 0.25rem;
  padding-left: 5px;
`;

export const BarcodeContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-wrap: nowrap;
`;

export const LoadPrePaidDialogContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  padding: 2rem 0;
`;

export const TimCardHeading = styled.h3`
  font-weight: ${Styles.fontWeight.heavy};
  color: ${primitive.th.$coffeeBrown};
  font-size: 1.25rem;
  margin-bottom: 1rem;
  margin-top: 0;
  text-align: center;
`;

export const NoConnectionHeading = styled(TimCardHeading)`
  display: none;
  ${Styles.desktop`
    display: unset;
  `}
`;

export const TimCardSubHeading = styled.h4`
  font-size: 1.125rem;
  font-weight: 400;
  margin: 0;
  opacity: 0.5rem;
  text-align: center;
  color: ${primitive.th.$coffeeBrown};
`;

export const Separator = styled.div`
  border: solid 1px #000000;
  height: 2px;
  opacity: 0.2;
  margin: 0.5rem 0;
  width: 100%;
`;

export const ContentBlock = styled.div<IMargin>`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-wrap: nowrap;
  margin: ${p => (p.margin ? p.margin : '1rem 0')};
  width: 100%;
`;

export const AmountContainer = styled.ul`
  display: flex;
  flex-direction: row;
  padding: 0;
  margin-top: 0;
  margin-bottom: 0.5rem;
  width: 100%;
  border-radius: 4px;
  min-height: 50px;
  border: 1px solid rgba(0, 0, 0, 0.1);
`;

export const MoneyButton = styled.button<IActiveButton>`
  margin: 0;
  color: ${props => (props.selected ? Styles.color.white : primitive.th.$coffeeBrown)};
  background-color: ${props => (props.selected ? Styles.color.primary : 'transparent')};
  border: none;
  cursor: pointer;
  font-weight: ${props => (props.selected ? 'bold' : 'normal')};
  font-size: 100%;
  flex: 1 1 auto;
  font-family: ${Styles.fontFamily.base};
  max-width: 25%;
  &:not(:last-child) {
    border-right: ${props => (props.selected ? 'none' : '1px solid rgba(0, 0, 0, 0.1)')};
  }
  &:hover {
    background-color: ${props =>
      props.selected ? Styles.color.primary : Styles.color.primaryHover};
    color: ${Styles.color.white};
  }
  &:first-child {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }
  &:last-child {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  &:focus {
    outline: 1px solid ${Styles.color.white};
  }
  & > div {
    width: fit-content(100%);
    max-width: 100%;
    max-height: 100%;
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: center;
  padding: 0.5rem;
`;

export const FinalActionContainer = styled(ActionContainer)`
  padding-bottom: 1.5rem;
  width: 100%;
`;

export const SelectPaymentMethodWrapper = styled.div`
  height: 100%;
  width: 100%;
`;
